module.exports = __webpack_public_path__ + "static/media/Slide06.70736aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide06.png
// module id = 1628
// module chunks = 0